export default __webpack_public_path__ + "static/media/safari-full.543a013c.svg";